import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class ForskerService {
  url = `${this.env.URL_FORSKER}`;
  headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

  constructor(
    private http: HttpClient,
    private env: EnvService
  ) { }

  post(user_prompt: string): Observable<any> {
    return this.http.post(this.url, `user_prompt=${user_prompt}`, { headers: this.headers });
  }

}
